export default __webpack_public_path__ + "static/media/asadullahbabur.aba2b4a9.jpg";